import React from "react";
import { useSession } from "../../../../../components/WebIM/Utils/useSession";
import { SubLayoutHeader } from "../../../../../components/Layouts/SubLayout/Component/SubLayoutHeader";

interface ChatHeaderProps {
    sessionId: string;
}

export default function ChatHeader({ sessionId }: ChatHeaderProps) {
    const { session } = useSession(sessionId);

    return <SubLayoutHeader title={session?.sessionTopic} />;
}
